import {
  ACTION_DELETE_ACCOUNT__REQUEST,
  ACTION_DELETE_ACCOUNT__SUCCESS,
  ACTION_DELETE_ACCOUNT__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_ACCOUNT__REQUEST:
    case ACTION_DELETE_ACCOUNT__SUCCESS:
      return null;

    case ACTION_DELETE_ACCOUNT__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
